import classes from "./CategoryTabs.module.css";

const categories = [
  { key: "all", label: "All" },
  { key: "chops", label: "Chops" },
  { key: "fruits", label: "Fruits" },
];

const CategoryTabs = ({ activeCategory, onChange }) => {
  return (
    <div className={classes.tabs} role="tablist" aria-label="Meal categories">
      {categories.map((item) => (
        <button
          key={item.key}
          className={`${classes.tab} ${
            activeCategory === item.key ? classes.active : ""
          }`}
          onClick={() => onChange(item.key)}
          role="tab"
          aria-selected={activeCategory === item.key}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default CategoryTabs;
